import {DialogDismiss, DialogFooter, DialogHeader} from '@/components/ui/dialog-atoms/DialogAtoms'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {StyledAgendaEventDetailsLoaderDialogBody} from '@/features/agenda/components/agenda-event-details-dialog/style'

export const AgendaEventDetailsLoaderDialog = () => {
    return (
        <>
            <DialogHeader>
                <Skeleton width="240px" height="32px" />
                <DialogDismiss />
            </DialogHeader>
            <StyledAgendaEventDetailsLoaderDialogBody>
                {Array.from({length: 10}).map((_, index) => (
                    <Skeleton key={index} width="100%" height="60px" />
                ))}
            </StyledAgendaEventDetailsLoaderDialogBody>
            <DialogFooter>
                <Flexbox justify="space-between" fullWidth>
                    <Skeleton width="120px" height="32px" />
                    <Flexbox gap={2} align="center">
                        <Skeleton width="100px" height="32px" />
                        <Skeleton width="100px" height="32px" />
                    </Flexbox>
                </Flexbox>
            </DialogFooter>
        </>
    )
}
